import axios from 'axios';

export const settingsRequest = () => axios.get('/v1/settings/public');
